export const media = {
	mobileS: (rules: TemplateStringsArray) => `@media (min-width: 17.5em) { ${rules} }`,
	mobileM: (rules: TemplateStringsArray) => `@media (min-width: 23.4375em) { ${rules} }`,
	mobileL: (rules: TemplateStringsArray) => `@media (min-width: 26.5625em) { ${rules} }`,
	tablet: (rules: TemplateStringsArray) => `@media (min-width: 48em) { ${rules} }`,
	laptop: (rules: TemplateStringsArray) => `@media (min-width: 64em) { ${rules} }`,
	desktop: (rules: TemplateStringsArray) => `@media (min-width: 90em) { ${rules} }`,
	desktopL: (rules: TemplateStringsArray) => `@media (min-width: 110em) { ${rules} }`,
	fourK: (rules: TemplateStringsArray) => `@media (min-width: 160em) { ${rules} }`,
}
